import React, { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";

import PageLoader from "components/common/PageLoader";
import { getEmployeeDetails } from "selectors/employee";
import { getEmployeeBankDetails, getBanksList } from "services/talent/bankDetails";

import "./BankDetails.scss";

function NoBankDetailsScreen() {
  return (
    <div className="no-bank-details-screen-wrapper">
      <p className="para-body-l-regular no-bank-details-added-text">No bank details added yet</p>
    </div>
  );
}

function BankDetails() {
  const [bankDetails, setBankDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const employeeDetails = useSelector(getEmployeeDetails);
  const employeeId = employeeDetails?.employeeId;

  const fetchBankDetails = useCallback(async () => {
    if (!employeeId) {
      setIsLoading(false);
      return;
    }

    try {
      setIsLoading(true);
      const [banksResponse, employeeResponse] = await Promise.all([getBanksList(), getEmployeeBankDetails(employeeId)]);

      if (employeeResponse?.payload?.bankDetails) {
        const bankDetailsData = employeeResponse.payload.bankDetails;
        const details = Array.isArray(bankDetailsData) ? bankDetailsData[0] : bankDetailsData;

        if (details) {
          const bankName =
            banksResponse?.payload?.find((bank) => (bank.id || bank.bankId) === (details.bankId || details.bank?.id))
              ?.name ||
            details.bankName ||
            "";

          setBankDetails({
            bankName,
            accountNumberLast4: details.accountNumberLast4 || "",
            pensionFund: details.pensionFund || "",
          });
        }
      }
    } catch (error) {
      console.error("Failed to load bank details:", error);
    } finally {
      setIsLoading(false);
    }
  }, [employeeId]);

  useEffect(() => {
    fetchBankDetails();
  }, [fetchBankDetails]);

  if (isLoading) {
    return <PageLoader />;
  }

  if (!bankDetails) {
    return <NoBankDetailsScreen />;
  }

  return (
    <div className="employee-bank-details-wrapper">
      <div className="bank-details-row">
        <div className="bank-detail-item">
          <p className="heading-h5-regular bank-detail-label">Bank name</p>
          <p className="para-body-m-medium bank-detail-value">{bankDetails.bankName || "-"}</p>
        </div>
        <div className="bank-detail-item">
          <p className="heading-h5-regular bank-detail-label">Bank account number</p>
          <p className="para-body-m-medium bank-detail-value">
            {bankDetails.accountNumberLast4 ? `**** **** **** ${bankDetails.accountNumberLast4}` : "-"}
          </p>
        </div>
      </div>
      <div className="bank-details-row">
        <div className="bank-detail-item">
          <p className="heading-h5-regular bank-detail-label">Pension fund (AFP/ONP)</p>
          <p className="para-body-m-medium bank-detail-value">{bankDetails.pensionFund || "-"}</p>
        </div>
      </div>
    </div>
  );
}

export default BankDetails;
